export const EMAIL_STORAGE_KEY = 'loginEmail'

export const PUBLIC_WATCHLIST = 'e416df97-5363-40ab-8f7d-25a782d26b22'
